module.exports = __webpack_public_path__ + "static/media/soft skills.2591583e.png";